import { computed, Injectable } from '@angular/core';
import { ComponentStoreV2Factory } from '../../../../../shared/store/common/component-store-v2.factory';
import { MpsvTargetGroupObject } from '@libs/types/src/list/object-type/mpsv-target-group.object';
import { mpsvTargetGroupFrag } from '../../../../../../services/types/mpsv-target-group.types';
import { InfiniteScrollStore } from '../../../../../shared/store/common/infinite-scroll.store';
import { FolderGroupObject } from '@libs/types/src/services/object-type/folder/folder-group.object';
import {
    SocialServiceOfferGroupObject,
} from '@libs/types/src/services/object-type/service/social-service/social-service-offer-group.object';

@Injectable()
export class ServiceGroupsUpsertDialogStore extends ComponentStoreV2Factory {
    public readonly mpsvTargetGroupScroll = new InfiniteScrollStore<MpsvTargetGroupObject>(
        this.api.getListMpsvTargetGroups,
        {},
        false,
        mpsvTargetGroupFrag,
    );

    public folderIds = computed<number[]>(() => (this.data.getFolderGroups()?.['items'] || [])
        .map((fg: FolderGroupObject) => fg.folderId));

    public offerIds = computed<number[]>(() => (this.data.getSocialServiceOfferGroups()?.['items'] || [])
        .map((og: SocialServiceOfferGroupObject) => og.offerId));
}
